import{mdiCheck as t}from"@mdi/js";import e from"react";import{MdIcon as o}from"./MdIcon.js";const r=({id:r="check",title:i="Check",...m})=>e.createElement(o,{id:r,title:i,path:t,...m});export{r as CheckIcon};
